import { Flex, csx } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'

import type { Item } from 'typings'

type Props = {
  item: Item
  maxWidth?: number | string
}

export function ItemRenderer(props: Props) {
  const { item, maxWidth = 'full' } = props
  const { formatMessage } = useIntl()

  const fullLabel = formatMessage(
    { id: 'admin/promotions.form.utils.item-label' },
    { ...item }
  )

  return (
    <Flex
      direction="row"
      className={csx({ maxWidth, whiteSpace: 'pre' })}
      title={fullLabel}
      data-testid={`multiselect-item-${item.id}`}
    >
      <FormattedMessage
        id="admin/promotions.form.utils.item-label"
        values={{
          ...item,
          name: (
            <p
              className={csx({
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              })}
            >
              {item.name}
            </p>
          ),
        }}
      />
    </Flex>
  )
}
